import * as React from 'react';

import { ExternalUrl, InternalUrl, StaticPosition } from './menuPosition.styled';
import { MenuPositionProps } from './menuPosition.types';

export const MenuPosition: React.FC<MenuPositionProps> = (props: MenuPositionProps) => {
  const {
    label,
    externalUrl,
    internalPath,
    action,
    shouldOpenInNewTab = false,
    children,
    disabled = false,
    download,
    className
  }: MenuPositionProps = props;

  if (externalUrl) {
    return (
      <ExternalUrl
        className={className}
        href={externalUrl}
        target={shouldOpenInNewTab ? '_blank' : '_self'}
        onClick={(!disabled && action) ? action : undefined}
        $disabled={disabled}
        download={download}
      >
        {children ?? label}
      </ExternalUrl>
    );
  } else if (internalPath) {
    return (
      <InternalUrl
        className={className}
        to={internalPath}
        onClick={(!disabled && action) ? action : undefined}
        $disabled={disabled}
      >
        {children ?? label}
      </InternalUrl>
    );
  } else if (action) {
    return (
      <StaticPosition
        className={className}
        onClick={!disabled ? action : undefined}
        disabled={disabled}
        type='button'
      >
        {children ?? label}
      </StaticPosition>
    );
  } else {
    return <>{children ?? label}</>;
  }
};
